import React from "react";
import ProductModalWrapper from "../ProductModalWrapper";

import styles from "./MainApp.organisms.Product.Modals.WrongFileModal.module.scss";
import i18n from "i18n";
export class WrongFileModal extends React.Component {
  render() {
    const {
      open,
      message,
      handleClose,
      handleGoBack,
      handleDownloadTemplate,
      handleClick,
    } = this.props;

    const content = (
      <div className={styles["wrong-file-modal-wrapper"]}>
        <div className={styles["wrong-file-modal-title"]}>{i18n.t("wrong.file")}</div>
        <div className={styles["wrong-file-modal-text"]}>{message}</div>
      </div>
    );
    return (
      <div className={styles["wrong-file-modal-container"]}>
        <ProductModalWrapper
          open={open}
          innerContent={content}
          buttonLegend={i18n.t("upload.another.file")}
          handleGoBack={handleGoBack}
          handleDownloadTemplate={handleDownloadTemplate}
          handleClose={handleClose}
          handleClick={handleClick}
        ></ProductModalWrapper>
      </div>
    );
  }
}

WrongFileModal.propTypes = {};

export default WrongFileModal;
